import React from 'react';
import { Link } from '@reach/router';
import clsx from 'clsx';

function SpinnerIcon() {
    return (
        <svg
            className="w-4 h-4 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
        </svg>
    );
}

export default function Button({
    children,
    disabled,
    link,
    onClick,
    type,
    secondary,
    loading,
    className,
    ...rest
}: {
    children: React.ReactNode;
    type?: 'button' | 'submit';
    secondary?: boolean;
    link?: string;
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    [props: string]: unknown;
}) {
    const baseClasses =
        'inline-flex items-center justify-center gap-2 rounded-lg text-sm font-semibold px-4 py-2 transition-colors focus:outline-none';

    if (link) {
        return (
            <Link
                to={link}
                className={clsx(
                    baseClasses,
                    'bg-orange-500 text-white hover:opacity-90',
                    className
                )}
            >
                {children}
            </Link>
        );
    }

    return (
        <button
            className={clsx(
                baseClasses,
                secondary
                    ? 'bg-surface-muted text-foreground border border-border hover:border-border-strong'
                    : 'bg-orange-500 text-white',
                disabled ? 'opacity-40 cursor-not-allowed' : !secondary && 'hover:opacity-90',
                className
            )}
            onClick={onClick}
            disabled={disabled}
            // eslint-disable-next-line react/button-has-type
            type={type || 'button'}
            {...rest}
        >
            {loading ? (
                <>
                    <SpinnerIcon />
                    <span>{typeof children === 'string' ? children : 'Loading...'}</span>
                </>
            ) : (
                children
            )}
        </button>
    );
}
